export const X_PER_WEEK = "XPerWeek";
export const X_PER_MONTH = "XPerMonth";
export const CREDIT = "Credit";
export const UNLIMITED = "Unlimited";

export const MASTER_TARIFF = "_masterTariff_";

export default [X_PER_MONTH, X_PER_WEEK, CREDIT, UNLIMITED];
